module.exports = __webpack_public_path__ + "static/media/featured_img_two.439c2354.png";